import Vue, { CreateElement } from "vue";

export default Vue.extend({
  render(h: CreateElement) {
    return h("div", { class: "dropdown-divider" });
  }
});
